import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="bg-slate-950 border-t border-slate-800 py-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-start gap-8">
          {/* Contact Information - Left Side */}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-semibold text-white">Contact Us</h3>
            <div className="flex flex-col gap-3">
              <a 
                href="tel:+12342051010" 
                className="inline-flex items-center gap-2 text-slate-300 hover:text-orange-400 transition-colors"
                data-testid="footer-phone-1"
              >
                <Phone className="h-5 w-5 text-orange-400" />
                <span className="text-base font-medium">(234) 205-1010</span>
              </a>
              <a 
                href="tel:+12342051043" 
                className="inline-flex items-center gap-2 text-slate-300 hover:text-orange-400 transition-colors"
                data-testid="footer-phone-2"
              >
                <Phone className="h-5 w-5 text-orange-400" />
                <span className="text-base font-medium">(234) 205-1043</span>
              </a>
              <a 
                href="mailto:support@remodworks.com" 
                className="inline-flex items-center gap-2 text-slate-300 hover:text-orange-400 transition-colors"
                data-testid="footer-email"
              >
                <Mail className="h-5 w-5 text-orange-400" />
                <span className="text-base font-medium">support@remodworks.com</span>
              </a>
              <div className="inline-flex items-center gap-2 text-slate-400 mt-2">
                <MapPin className="h-5 w-5 text-orange-400" />
                <span className="text-sm">Serving Northeast Ohio</span>
              </div>
            </div>
          </div>

          {/* Copyright - Right Side */}
          <div className="flex flex-col items-start lg:items-end gap-2">
            <p className="text-sm text-slate-500" data-testid="copyright">© {currentYear} RemodWorks</p>
            <p className="text-xs text-slate-600">Veteran-Owned Business</p>
          </div>
        </div>
      </div>
    </footer>
  );
};
